import React from "react";
import PropTypes from "prop-types";
import DialogContent from "@mui/material/DialogContent";
import DialogActions from "@mui/material/DialogActions";
import { useUser } from "../../../context/api.js";
import { formatDate } from "../../../utils/date.js";
import MDTypography from "../../../components/MDTypography";
import MDButton from "../../../components/MDButton";

function AlreadyValidated({ m, children, title, onCancel }) {
  const user = useUser();

  if (m.done) {
    return (
      <>
        <DialogContent>
          {title}
          <MDTypography variant="body" component="div" mt={2}>
            {m.validator_id === user.id && "Vous avez validé cette étape le "}
            {m.validator_id !== user.id &&
              "Cette étape a été validé " +
                (m.validator_id === "SYSTEM" ? "automatiquement" : "par " + m.validator_id) +
                " le "}
            <span style={{ textDecoration: "underline" }}>{formatDate(m.validation_date)}</span>.
          </MDTypography>
        </DialogContent>
        <DialogActions>
          {/* TODO : Review/cancel validation */}
          <MDButton variant="contained" onClick={onCancel}>
            Fermer
          </MDButton>
        </DialogActions>
      </>
    );
  }

  return children;
}

AlreadyValidated.propTypes = {
  m: PropTypes.object,
  onCancel: PropTypes.func,
  title: PropTypes.element,
  children: PropTypes.node,
};

export default AlreadyValidated;
